import { Component, enableProdMode } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import {LargereceiptService} from '../app/service/largereceipt.service'
import { IMessageDetails, MessageDetailsResponse,IReceiptFileUploadDetails,ISenderDetails,IReceiptDownloadDetails } from '../app/class/largereceipt';
import { AppError } from './common/class/app-error';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showLogo: boolean = false;
  title = 'ReceiptAuthenticationSite';
  showSpinner:boolean=true;
  messageId:any;
  appLang:any;
  // loadingImage:string= "../../assets/Images/loading-1.gif"
  constructor(private translate: TranslateService,private router:Router
    ,private largeReceiptSvc:LargereceiptService
    ,private route: ActivatedRoute) {
     
    if(localStorage.getItem("MessageId")!=null && 
    localStorage.getItem("MessageId")!=undefined)
    {
      this.messageId=localStorage.getItem("MessageId");
    }
    //alert(this.messageId);
      if(this.appLang==null)
      {
          this.largeReceiptSvc.getMessageDetailsFromServer(this.messageId)
          .subscribe(async resp => {
            if (!(resp instanceof AppError)) {      
              
              const response = resp as IMessageDetails;
              //alert(response.ResultContent.Language);
              this.appLang=response.ResultContent.Language;
              if(this.appLang!=null)
                translate.setDefaultLang(this.appLang);
              else
                translate.setDefaultLang('en-us');

            }
          });
      }
       
    $("#idSpinner").css("display","block");
    
    
    
}

ngOnInit(): void {
  $("#preload-panel").css("display","none");
  
  
    
}

}
